import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/tariffs`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(payload) {
    const { id, ...queryParams } = payload;

    console.log('tariff service:get-id',id);

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
        params: queryParams
    };

    return axios.get(`${url}/tariffs/${id}`, options)
        .then(response => {
            let tariffs = jsona.deserialize(response.data);
            delete tariffs.links;
            return tariffs;
        });
}


function show(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/tariffs/${id}`, options)
        .then(response => {
            let tariffs = jsona.deserialize(response.data);
            delete tariffs.links;
            return tariffs;
        });
}

function add(tariffs) {
    console.log(tariffs);
    const payload = jsona.serialize({
        stuff: tariffs,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/tariffs`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(tariff) {
    const payload = jsona.serialize({
        stuff: tariff,
        includeNames: ['stations', 'vendor']
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/tariffs/${tariff.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function activities(id) {
    let options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };
    return axios.get(`${url}/tariffs/${id}/activity`, options)
        .then(response => {
            console.log(response.data);
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/tariffs/${id}`, options);
}

export default {
    list,
    get,
    show,
    activities,
    add,
    update,
    destroy
};

